module.exports = __webpack_public_path__ + "static/media/event-banner.45dd02d0.png";